<template>


    <div class="bg-white rounded-lg shadow-md">


        <div class="p-4 flex" style="height: 100%">


            <div class="bg-blue rounded-lg flex justify-center mr-6" style="height: 100%; width: 70px">

                <font-awesome-icon
                    class="mr-1 text-white"
                    style="margin: auto; width: auto; height: 40%"
                    :icon="[icon_type, icon]" />

            </div>


            <div class="">


                <p class="text-gray-600">

                    {{ title }}

                </p>


                <div class="flex">


                    <h2 class="text-3xl">

                        {{ format_value(count) }}{{ value_type }}

                    </h2>


                    <span class="self-end ml-4"
                       :class="{
                            'text-green': is_trend_positive,
                            'text-red-600': ! is_trend_positive,
                            'text-black': is_trend_positive === null
                       }">


                        <font-awesome-icon
                            class="mr-1 font-bold"
                            style=""
                            v-if=" ! is_trend_opposite && is_trend_positive !== null"
                            :icon="['fas', is_trend_positive ? 'arrow-up' : 'arrow-down']" />


                        <font-awesome-icon
                            class="mr-1 font-bold"
                            style=""
                            v-else-if="is_trend_opposite && is_trend_positive !== null"
                            :icon="['fas', ! is_trend_positive ? 'arrow-up' : 'arrow-down']" />

                        <div v-else></div>

                        {{ format_value(trend) }}{{ value_type }}

                    </span>


                </div>


            </div>


        </div>


    </div>


</template>


<script>
import { defineComponent } from "vue";
import DialogModal from "../Jetstream/DialogModal";
export default defineComponent( {

    name: "CountWidget",

    components: {
        DialogModal
    },

    props: {
        title: {
            type: String,
            default: 'Title'
        },
        count: {
            type: Number,
            default: 1333
        },
        trend: {
            type: Number,
            default: 22
        },
        icon: {
            type: String,
            default: 'user'
        },
        icon_type: {
            type: String,
            default: 'fas'
        },
        value_type: {
            type: String,
            default: ''
        },
        is_trend_opposite: {
            type: Boolean,
            default: false
        }
    },
    computed: {

        is_trend_positive() {

            if (this.trend === 0 && this.is_trend_opposite !== null) {
                return null;
            }

            return (
                ! this.is_trend_opposite && this.trend > 0
                || this.is_trend_opposite && this.trend < 0
            );

        },

    },
    methods: {

        format_value(value) {

            let number;

            value = _.round(value,1);

            number = Math.abs( value ) > 999
                ? Math.sign( value ) * ((Math.abs( value )/1000).toFixed(1)) + 'k'
                : Math.sign( value ) * Math.abs( value );

            return number;

        }

    }
});
</script>

<style scoped>

</style>
